import { useCallback, useState } from 'react';

const currentVersion = process.env.REACT_APP_VERSION || '';

export interface AppMeta {
  version: string;
}

export interface AppMetaInfo {
  meta?: AppMeta;
  didUpdate: boolean;
  currentVersion: string;
}

export async function getAppMeta(): Promise<AppMetaInfo> {
  let meta: AppMeta | undefined;
  try {
    // meta.json can get cached, add unique query every time to prevent cache
    const response = await fetch(`/meta.json?t=${+Date.now()}`);
    meta = await response.json();
  } catch {}
  // compare via equality in case a lower version build is pushed
  const didChange = !!(
    meta &&
    currentVersion &&
    meta.version !== currentVersion
  );
  return { meta, didUpdate: didChange, currentVersion };
}

export function useAppMeta() {
  const [metaInfo, setMetaInfo] = useState<AppMetaInfo>(() => {
    return { currentVersion, didUpdate: false };
  });
  const loadMeta = useCallback(() => {
    getAppMeta().then(setMetaInfo);
  }, []);
  return { ...metaInfo, loadMeta };
}
